import { PayloadAction } from "@reduxjs/toolkit";

import { StationsState } from '../../types';

export const updateSelectedStationOnMap = (
  state: StationsState,
  action: PayloadAction<StationsState['selectedStationOnMap']>
) => {
  state.selectedStationOnMap = action.payload
};
